import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { FormikActions } from 'formik';
import { TFunction } from 'react-i18next';
import { Action, withInject } from '@piwikpro/platform';
import {
  Text,
  Stack,
  withTranslation,
} from '@piwikpro/ui-components';
import { Apps } from '@piwikpro/apps-crate';
import { FormValidator } from '@piwikpro/form-crate';
import { AdministrationState, STATE_ROOT } from '../../../../../redux';

const mapStateToProps = (state: AdministrationState) => {
  const { settings } = state[STATE_ROOT].apps.details.settings;

  return {
    app: settings as NonNullable<typeof settings>,
  };
};

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  apps: Apps
  validation: FormValidator
}

interface Props extends ReduxProps, InjectedProps {
  t: TFunction
}

interface FormValues {
  delay: number
}

class GeneralDelay extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: FormValues, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: FormikActions<FormValues>) {
    const { apps, app } = this.props;

    try {
      await apps.update(app.id, values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        'delay',
        app.attributes.delay,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      app,
      validation,
      t,
    } = this.props;

    return (
      <Stack vertical verticalAlignment="center">
        <Stack.Item fill>
          <Stack vertical spacing="narrow">
            <Stack.Item>
              <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.general.delay.title')}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text as="p">{t('apps.details.settings.general.delay.description')}</Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item fill>
          <Action.DelayedAutoSavedNumberControl
            dataId="GeneralDelayControl"
            id="apps-settings-general-delay"
            name="delay"
            type="number"
            required
            initialValue={app.attributes.delay}
            units="ms"
            validationSchema={validation.createValidationSchema(validators => ({
              delay: validators.apps.delay,
            }))}
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
      </Stack>
    );
  }
}

export default connector(withInject<InjectedProps>({
  apps: 'AppsCrate.apps',
  validation: 'FormCrate.validation',
})(
  withTranslation(['administration'])(GeneralDelay),
));
